export const engineeringfaqList = [
  {
    question: 'Should all the losses that are under the deductible be reported?',
    answer:
      'If the loss is below the deductible, it is not recommended to report it to the insurance provider. If one is not sure about the final amount of loss or deductible amount, it is recommended to contact the insurer.',
  },
  {
    question: 'What is the duration of Contractors All Risk Insurance policy?',
    answer:
      'Unlike other insurance policies, the Contractors All Risk Insurance plan is issued for the period of the contract that is from the starting of work until the work completes. Even though it is possible to extend the period of the policy if the completion of the contract gets delayed, but it is always wise to choose a slightly longer insurance period initially for avoiding paying a higher premium in case of extension.',
  },
  {
    question: 'For what value of machine the insurance should be purchased?',
    answer:
      'It is a requirement of this insurance that the sum insured be equal to the cost of replacement of the machines by new machines of the same kind and same capacity, which shall mean its replacement, or reinstatement cost, including freight, custom duties, if any, and erection costs.',
  },
  {
    question: 'Can we cover loss due to design defects in the engineering policy?',
    answer:
      'Yes, you can cover the costs of project damages caused by design flaws. Damage due to design is an exclusion in a normal policy, but by paying an additional premium, you can cover the design flaw in the policy. There are other forms of design defect cover, such as design defect-3 and design defect-4, that can be added to the policy as an add-on for an additional premium. We advise all of our clients to include this coverage in their erection all risk insurance.',
  },
];
